export default __webpack_public_path__ + "static/media/quizzical-login-large.7b8fe604.jpg";